/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * The type of reward, currently only supports XP.
 * @export
 * @enum {string}
 */
export enum OWRewardType {
    XP = 'XP',
    FUEL = 'FUEL',
    NFT = 'NFT'
}

export function OWRewardTypeFromJSON(json: any): OWRewardType {
    return OWRewardTypeFromJSONTyped(json, false);
}

export function OWRewardTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): OWRewardType {
    return json as OWRewardType;
}

export function OWRewardTypeToJSON(value?: OWRewardType | null): any {
    return value as any;
}

